const HEADER_NAME = 'x-bypass'

function stripTrailingSlashes(s) {
  return s.replace(/\/+$/, '')
}

function normalizeEnv(value) {
  return typeof value === 'string' ? value.trim() : ''
}

function getDashboardApiPrefixes() {
  return [
    normalizeEnv(process.env.REACT_APP_BASEURL),
    normalizeEnv(process.env.REACT_APP_MS_IDENTITY_API),
    normalizeEnv(process.env.REACT_APP_CLIENT_SERVICES_API),
    normalizeEnv(process.env.REACT_APP_BASEURLRV),
    normalizeEnv(process.env.REACT_APP_USER_CONFIG_BASEURL),
  ]
    .filter(Boolean)
    .map(stripTrailingSlashes)
}

/**
 * Avoid prefix matching another origin (e.g. https://api.com matching https://api.com.evil.com).
 */
function urlMatchesDashboardPrefix(urlString, prefix) {
  if (!urlString.startsWith(prefix)) return false
  if (urlString.length === prefix.length) return true
  const next = urlString[prefix.length]
  return next === '/' || next === '?'
}

function isDashboardApiUrl(urlString, prefixes) {
  return prefixes.some((p) => urlMatchesDashboardPrefix(urlString, p))
}

/** Solo el POST de login al backend principal (loginApi). */
function isAuthLoginPost(request) {
  if (request.method !== 'POST') return false
  try {
    const { pathname } = new URL(request.url)
    return pathname === '/auth/login' || pathname.endsWith('/auth/login')
  } catch {
    return false
  }
}

function shouldAttachBypassHeader(request, prefixes) {
  if (!isDashboardApiUrl(request.url, prefixes)) return false
  if (request.method === 'GET') return true
  return isAuthLoginPost(request)
}

let installed = false

export function installFetchBypassForDashboardApis() {
  if (installed) return
  installed = true

  const bypassValue = normalizeEnv(process.env.REACT_APP_X_BYPASS)
  if (!bypassValue) return

  const prefixes = getDashboardApiPrefixes()
  if (prefixes.length === 0) return

  const nativeFetch = window.fetch.bind(window)

  window.fetch = function patchedFetch(input, init) {
    const request = new Request(input, init)

    if (!shouldAttachBypassHeader(request, prefixes)) {
      return nativeFetch(request)
    }

    const headers = new Headers(request.headers)
    headers.set(HEADER_NAME, bypassValue)
    return nativeFetch(new Request(request, { headers }))
  }
}

installFetchBypassForDashboardApis()
